module.exports = __webpack_public_path__ + "img/logo-intel-white.8efaac23.png";